/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  ProductionService,
  type Wealthlane_Dtos_Production_ProductionResponseDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

export interface PushToProductionPayload {
  sandboxTenantId: string;
  remarks?: string | null;
  keepRoleOverrides?: boolean;
}

const usePostPushToProduction = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Dtos_Production_ProductionResponseDto | undefined,
  unknown,
  PushToProductionPayload,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: PushToProductionPayload) => {
      return await handleRequest(
        ProductionService.postApiIdentityApiProduction({
          SandboxTenantId: payload.sandboxTenantId,
          Remarks: payload.remarks ?? undefined,
          KeepRoleOverrides: payload.keepRoleOverrides ?? true,
        })
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          void queryClient.invalidateQueries('getSandboxProductionList');
          closeModal();
          toast.success(<ToastComponent label='Success' message='Sandbox Pushed to Production.' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostPushToProduction;
